
import { required } from 'vuelidate/lib/validators'

export default {
  pet: {
    tower_id: {
      required
    },
    unit_id: {
      required
    },
    name: {
      required
    },
    species: {
      required
    },
    breed: {
      required
    },
    color: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/pets/form/resources/validations.js